import { SIcon } from '@strana-artw/ui-kit';
export default {
  name: 'HintTooltip',
  components: {
    SIcon: SIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    openHintModal: function openHintModal() {
      if (this.$breakpoint.mdAndDown) {
        this.$modal.open({
          component: 'ModalHint',
          attrs: {
            title: this.title,
            text: this.text
          }
        });
      }
    }
  }
};